export const buildFormData = (fields) => {
  return Object.fromEntries(
    fields.map(field => {
      return [field.cleanName, field.defaultValue]
    })
  )
}
